<h1 class="h3 mb-2 text-gray-800">Doctores</h1>
<!-- <p class="mb-4">DataTables is a third party plugin that is used to generate the demo table below. For more information
    about DataTables, please visit the <a target="_blank" href="https://datatables.net">official DataTables
        documentation</a>.</p> -->

<!-- DataTales Example -->
<div class="card shadow mb-4">
    <div class="card-header py-3">
        <h6 class="m-0 font-weight-bold text-primary">Formulario de Contenidos</h6>
    </div>
    <div class="card-body">
        <form name="form" (ngSubmit)="f.form.valid && guardarDatos()" #f="ngForm">
            <div class="form-group">
                <label>Nombre</label>
                <input type="text" class="form-control" #key="ngModel" name="key" [(ngModel)]="contenido.key" required
                    [ngClass]="{'is-invalid':  f.submitted && key.invalid}" />
                <div *ngIf="f.submitted && key.invalid" class="invalid-feedback">
                    <div *ngIf="key.errors.required">El nombre del contenido es requerido
                    </div>
                </div>
            </div>
            <div class="form-group">
                <label>Valor</label>
                <ckeditor *ngIf="( Editor && config )" [editor]="Editor" [config]="config" br name="value"
                    #theVal="ngModel" [(ngModel)]="contenido.value" [editor]="Editor" required [config]="config"
                    [ngClass]="{'is-invalid':  f.submitted && theVal.invalid}">
                </ckeditor>
                <div *ngIf="Editor && config && f.submitted && theVal.invalid" class="invalid-feedback">
                    <div *ngIf="theVal.errors.required">El contenido es requerido
                    </div>
                </div>
            </div>
            <div class="form-group">
                <button type="submit" class="btn btn-primary">Guardar Datos</button>
                <a routerLink="/contenidos" class="btn btn-link">Volver</a>
            </div>
        </form>
    </div>
</div>